import script from "./Team.vue?vue&type=script&lang=ts&setup=true"
export * from "./Team.vue?vue&type=script&lang=ts&setup=true"

import "./Team.vue?vue&type=style&index=0&id=5da94353&lang=less"

const __exports__ = script;

export default __exports__